/**
 * Created by 唐亦慧 on 2018/2/6.
 */
import React from 'react';
import {Layout, Form, Row, Col, Input, Upload, Button, message} from 'antd';
const FormItem = Form.Item;
import {hashHistory} from 'react-router';
import '../mallApp.css';
const {Header} = Layout;
import {payDetail, orderPay} from '../../service/mall/index';
import config from '../../utils/config';
import {returnFloat, showSpin, hideSpin} from '../../utils/index';

class SubmitOrder extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			payDetail: {},
			method: ['对公转账'], // ['对公转账', '线上支付'],
			payKey: 0,
			payId: this.props.params.id || 0,
			imgUrls: [
				require('../../assets/images/pc-pay.png'),
				require('../../assets/images/pc-weixin.png'),
				require('../../assets/images/pc-zhifubao.png')
			],
			imgKey: 0,
			picIds: []
		}
		this.goView = this.goView.bind(this);
		this.changeKey = this.changeKey.bind(this);
		this.submitHandle = this.submitHandle.bind(this);
		this.getPayDetail = this.getPayDetail.bind(this);
		this.changeImgKey = this.changeImgKey.bind(this);
		this.checkMoney = this.checkMoney.bind(this);
	}

	componentDidMount() {
		if (parseInt(this.state.payId, 10)) {
			this.getPayDetail(parseInt(this.state.payId, 10))
		}
	}

	/*获取详情*/
	getPayDetail(id) {
		payDetail({id: id}).then((result) => {
			if (result && result.status) {
				this.setState({
					payDetail: result.data
				})
			} else {
				message.error(result.message);
			}
		})
	}

	//页面跳转
	goView(url) {
		hashHistory.push(url);
	}

	changeKey(key) {
		this.setState({
			payKey: key
		})
	}

	changeImgKey(key, e) {
		e.preventDefault();
		e.stopPropagation();
		this.setState({
			imgKey: key
		})
	}

	submitHandle() {
		const {validateFields, getFieldsValue} = this.props.form;
		const {payDetail, payId, picIds} = this.state;
		validateFields((errors) => {//表单校验
			if (errors) {
				return
			}//表单校验有误，则不执行下面的代码
			const data = {
				...getFieldsValue() //获取用户输入
			};
			showSpin();
			orderPay({
				amount: data.pay,
				orderId: parseInt(payId, 10),
				picIdList: picIds
			}).then((result) => {
				hideSpin();
				if (result && result.status) {
					message.success(result.message);
					window.localStorage.setItem('orderNum', JSON.stringify({
						code: payDetail.code,
						orderId: parseInt(payId, 10),
						status: 1
					}));
					hashHistory.push(`/mallCommon/mallOrder/${payId}`)
				} else {
					message.error(result.message);
				}
			})
		})
	}

	toggleHome() {
		let url = window.location.href;
		if (/dms-pc/.test(url)) {
			window.location.href = url.split('dms-pc')[0] + 'dms-pc/#/home';
		} else {
			window.location.href = '/#/home'
		}
	}

	//排序正则
	checkMoney(rule, value, callback) {
		const limitMoney = this.state.payDetail.unpaidAmount - 0;
		const vaReg = /^\d+\.{0,1}\d{0,2}$/;
		if (value) {
			if (!(vaReg.test(value))) {
				callback('只能输入数字和小数点，小数点后位数最多2位');
			} else {
				if (value <= 0 || value > limitMoney) {
					callback('本次支付金额必须大于0，小于等于待支付金额');
				}
			}
			callback();
		}
		callback();
	}

	render() {
		const {payDetail, method, payKey, imgUrls, imgKey, picIds} = this.state;
		const {getFieldDecorator} = this.props.form;
		var self = this;
		const uploadProps = {
			name: "file",
			action: `${config.fc_server}/file/v6/upload`,
			headers: {"corTicket": window.localStorage.getItem('cor-ticket') || ''},
			listType: "picture",
			data: {"source": 'dms'},
			onChange: result => {
				if (result.file.status === 'done') {
					var picAdd = [];
					for (var f = 0; f < result.fileList.length; f++) {
						picAdd.push(result.fileList[f].response.data.id)
					}
					self.setState({
						picIds: picAdd
					});
				}
			},
			onRemove(file){
				if (file.response.status == true) {
					var picMinus = picIds;
					picMinus.splice(picMinus.indexOf(file.response.data.id), 1);
					self.setState({
						picIds: picMinus
					});
				}
			},
			showUploadList: true,
			multiple: false,
		};
		return <div>
			<Layout style={{background: '#fff'}}>
				<Header id='mall-cart'>
					{/*<div className="mall-logo">
						<a href="#" style={{cursor: 'default'}}>
							<h1>
								前海圆舟
							</h1>
						</a>
					</div>*/}
					<div className="cart-word">收 银 台</div>
					{/*<div className="mall-go" onClick={this.toggleHome}>
						切换到卖家
					</div>*/}
					<div style={{
						float: 'left',
						fontSize: '16px',
						color: '#000',
						margin: '26px 0 0 8%'
					}}>订单金额：{returnFloat(payDetail.amount || 0)}</div>
				</Header>
			</Layout>
			<div style={{padding: '0 50px 50px 50px', background: "#fff"}}>
				<div className="go-pay">
					<div className='pay-top'>
						<span>订单号：{payDetail.code}</span>
						<p>待付款：<span>{returnFloat(payDetail.unpaidAmount || 0)}</span></p>
					</div>
					<div className="pay-down">
						<p>
							{
								method.map((value, key) => {
									return <span onClick={this.changeKey.bind(this, key)}
												 className={payKey == key ? 'pay-key' : ''} key={key}>{value}</span>
								})
							}
						</p>
						<div style={{padding: '16px 0'}}>
							{
								payKey == 0 &&
								<div>
									<Form layout="horizontal">
										<Row>
											<Col span={16}>
												<FormItem label="本次支付（元）"
														  labelCol={{span: 5}}
														  wrapperCol={{span: 11}}
														  hasFeedback>
													{getFieldDecorator('pay', {
														initialValue: payDetail.unpaidAmount || '',
														rules: [
															{
																required: true,
																message: '请输入本次支付金额'
															},
															{
																validator: this.checkMoney
															}
														]
													})(<Input placeholder="请输入本次支付金额"/>)}
												</FormItem>
											</Col>
										</Row>
										<Row>
											<Col span={16}>
												<FormItem label="转账凭证"
														  labelCol={{span: 5}}
														  wrapperCol={{span: 11}}
														  hasFeedback>
													{getFieldDecorator('upload', {
														valuePropName: 'fileList',
														getValueFromEvent(e){
															if (Array.isArray(e)) {
																return e;
															}
															return e && e.fileList;
														},
														rules: [
															{
																required: true,
																message: '请上传转账凭证'
															}
														]
													})(
														<Upload {...uploadProps}>
															<Button style={{
																borderColor: '#d61518',
																color: '#d61518'
															}}>&nbsp;&nbsp;上传&nbsp;&nbsp;</Button>
														</Upload>
													)}
												</FormItem>
											</Col>
										</Row>
									</Form>
									<div style={{
										marginLeft: '14%',
										color: '#fff',
										backgroundColor: '#d71418',
										borderColor: '#d71418',
										width: '108px',
										height: '28px',
										textAlign: 'center',
										lineHeight: '28px',
										borderRadius: '3px',
										cursor: 'pointer'
									}} onClick={this.submitHandle}>确认支付
									</div>
								</div>
							}

							{
								payKey == 1 &&
								<Row gutter={40}>
									{
										imgUrls.map((value, key) => {
											return <Col span={7} key={key} onClick={this.changeImgKey.bind(this, key)}>
												<div className={key == imgKey ? 'pay-method-choose' : 'pay-method'}>
													<img src={value} alt=""/>
													<span style={{
														width: '100%',
														height: '100%',
														dispaly: 'block',
														position: 'absolute',
														top: '0',
														left: '0',
														background: 'transparent',
														zIndex: '100'
													}}></span>
												</div>
											</Col>
										})
									}
								</Row>
							}
						</div>
					</div>
				</div>
			</div>

		</div>
	}
}
;
export default Form.create()(SubmitOrder);



// WEBPACK FOOTER //
// ./src/mall/mallPay/goPay.js